export const GET_USER_SMART_VIEWS = "GET_USER_SMART_VIEWS";
export const GET_USER_SMART_VIEWS_SUCCESS = "GET_USER_SMART_VIEWS_SUCCESS";
export const GET_USER_SMART_VIEWS_ERROR = "GET_USER_SMART_VIEWS_ERROR";

export const CREATE_USER_SMART_VIEWS = "CREATE_USER_SMART_VIEWS";
export const CREATE_USER_SMART_VIEWS_SUCCESS = "CREATE_USER_SMART_VIEWS_SUCCESS";
export const CREATE_USER_SMART_VIEWS_ERROR = "CREATE_USER_SMART_VIEWS_ERROR";

export const UPDATE_USER_SMART_VIEWS = "UPDATE_USER_SMART_VIEWS";
export const UPDATE_USER_SMART_VIEWS_SUCCESS = "UPDATE_USER_SMART_VIEWS_SUCCESS";
export const UPDATE_USER_SMART_VIEWS_ERROR = "UPDATE_USER_SMART_VIEWS_ERROR";

export const DELETE_USER_SMART_VIEWS = "DELETE_USER_SMART_VIEWS";
export const DELETE_USER_SMART_VIEWS_SUCCESS = "DELETE_USER_SMART_VIEWS_SUCCESS";
export const DELETE_USER_SMART_VIEWS_ERROR = "DELETE_USER_SMART_VIEWS_ERROR";

export const RESET_LAST_USER_SMART_VIEW_ACTION = "RESET_LAST_USER_SMART_VIEW_ACTION"